// EFM case categories (LA County — taxonomy is county-specific)
export const LA_COUNTY_CASE_CATEGORIES = [
    { code: 'appellate', name: 'Appellate', efmCode: 'AP' },
    { code: 'civil-limited', name: 'Civil Limited', efmCode: 'LC' },
    { code: 'civil-restraining-order', name: 'Civil Restraining Order', efmCode: '21' },
    { code: 'civil-unlimited', name: 'Civil Unlimited', efmCode: 'CU' },
    { code: 'family', name: 'Family', efmCode: '12' },
    { code: 'family-dcss', name: 'Family - DCSS', efmCode: '12' },
    { code: 'juvenile-dependency', name: 'Juvenile Dependency', efmCode: '14' },
    { code: 'probate', name: 'Probate', efmCode: '4' },
    { code: 'probate-mental-health', name: 'Probate or Mental Health', efmCode: '13' },
    { code: 'small-claims', name: 'Small Claims', efmCode: 'SC' },
];
export const getCaseCategories = (_county) => {
    // Currently only LA County data available; will be API-driven
    return LA_COUNTY_CASE_CATEGORIES;
};
